<bp-picture src="{{ assetsDir }}yellow-card-girl"></bp-picture>

<p>The best solution for online payments</p>

<div class="button">
	<span class="link nowrap youtube-blue">Watch Video</span>
</div>
